import styled from '@emotion/styled'
import React from 'react'

const CTAButton = styled.a`
  display: inline-block;
  margin-top: 8px;
  padding: 8px 16px;
  background: #102638;
  color: white;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;

  &:hover {
    background: #1a3a52;
  }
`

const BusinessCalendarCTA: React.FC = () => (
  <CTAButton href="/dash/business-calendar">Set up my Business Calendar →</CTAButton>
)

export default BusinessCalendarCTA
